import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { MeetingTemplateFormPresentation } from './meeting-template-form.presentration';
import { MeetingTemplatesFormVM } from './meeting-template-form.viewmodel';

export type MeetingTemplateFormProps = {
    accountId: number;
    blueprintId: string;
    apiCallSuccessCallback: () => void;
    deleteCompletionCallback: () => void;
};

export const MeetingTemplatesForm = withViewModel(MeetingTemplateFormPresentation, async (props: MeetingTemplateFormProps) => {
    const vm = new MeetingTemplatesFormVM(props.accountId, props.blueprintId, props.apiCallSuccessCallback, props.deleteCompletionCallback);
    await vm.initFormVM();

    return vm;
});
